<template>
  	<!-- Page Content Wrapper -->
  	<div id="page-content-wrapper" class="admin-content-area dashboard">
    	<div class="container-fluid xyz location-listing">
      		<div class="page-header-top-container" style="position: fixed;">
        		<div class="page-name" style="width:40%">Parts Usage Summary</div>
                <button type="submit" v-on:click.prevent="loadPartDepletionHistory(true)" class="btn btn-primary waves-effect pull-right">Export</button>
                <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadPartDepletionHistory(false)">
                    <i class="fa fa-rotate-right" aria-hidden="true"></i>
                </button>
        		<div class="page-name">
					<!-- <VueCtkDateTimePicker v-model="date_picker_dates"
						range
						:only-date="date_picker_options.onlyDate"
						:only-time="false"
						:output-format="date_picker_options.outputFormat"
						:format="date_picker_options.inputFormat"
						:formatted="date_picker_options.formatted"
						:noClearButton="date_picker_options.noClearButton"
						:custom-shortcuts="date_picker_options.customShortcuts"
						@input="changeDatePickerDate()"
						:maxDate="date_picker_options.maxDate"
					></VueCtkDateTimePicker> -->
                    <!-- <div class="row no-margin">
                        <div class="col-12 forms-block">
                            <div class="col-9 paddingleft0">
                                <v-select v-model="customerId" name="customerId" placeholder="Select Customer."
                                    label="text"
                                    @change="onChangeCustomer"
                                    :options="customerOptions" :clearable=false>
                                </v-select>
                            </div>
                        </div>
                    </div> -->
        		</div>
				<div class="selectbtn">
					<!-- <button type="submit" v-on:click.prevent="loadPartDepletionHistory(true)" class="btn btn-primary waves-effect pull-right">Export</button> -->
					<!-- <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="loadPartDepletionHistory(false)">Apply Filter</button> -->
					<!-- <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="clearFilter()">Clear Filter</button> -->
				</div>
      		</div>
      		<!--page content-->
      		<div class="admin-page-content" style="padding-top: 80px;">
                <label class="policy-text">** Total displayed below does not include Tax and Core Charges</label>
                <br>
                <label class="policy-text">** Please enter the PO Number displayed in the PO Number column prefixed with "CI-" when generating Invoice in Excede</label>
        		<div :class="'app-filter-good-table-container ' + isAdminClass">
                    <vue-good-table
                        ref="listInventory"
                        mode="remote"
                        title="Dashboard"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        @on-selected-rows-change="selectionChanged"
                        :columns="columns"
                        :rows="rows"
                        :selectOptions="dynamicSelectOptions"
                        :row-style-class="rowStyleClassFn"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'both',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">

                        <!-- Custome Pagination -->
                        <template slot="pagination-top" slot-scope="props">
                            <div class="vgt-wrap__footer top-pagination crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->
                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action' && props.formattedRow['customer_excede_id'] != 'Total'">
                                    <template v-if="isNonVVGDealer == 'NO'">
                                        <template v-if="app_country == 'US'">
                                            <template v-if="editUserId == 1 || editUserId == 122 || editUserId == 110 || editUserId == 125 || editUserId == 137">
                                                <router-link class="btn edit-btn-vvg waves-effect" title="Edit Inventory" v-bind:to="{name: 'UpdatePartDepletionHistory', params: {id:props.row.id}}">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </router-link>
                                            </template>
                                        </template>
                                        <template v-if="app_country == 'AU'">
                                            <template v-if="editUserId == 1 || editUserId == 101 || editUserId == 121 || editUserId == 114 || editUserId == 107 || editUserId == 110">
                                                <router-link class="btn edit-btn-vvg waves-effect" title="Edit Inventory" v-bind:to="{name: 'UpdatePartDepletionHistory', params: {id:props.row.id}}">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </router-link>
                                            </template>
                                        </template>
                                        <template v-if="app_country == 'CA'">
                                            <template v-if="editUserId == 1 || editUserId == 3">
                                                <router-link class="btn edit-btn-vvg waves-effect" title="Edit Inventory" v-bind:to="{name: 'UpdatePartDepletionHistory', params: {id:props.row.id}}">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </router-link>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <router-link class="btn edit-btn-vvg waves-effect" title="Edit Inventory" v-bind:to="{name: 'UpdatePartDepletionHistory', params: {id:props.row.id}}">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                    <i class="fa fa-info-circle" @click="viewNote(hideNoteFlag, props.row, $event, 'cust')" aria-hidden="true" style="padding:5px;line-height:30px;cursor:pointer;"></i>
                                    <a href="javascript:void(0)" class="btn edit-btn-vvg waves-effect" title="Add/Edit Backorder QTY Note" v-on:click="addEditBackorderQtyNote(props.row.id, props.row.back_order_qty_note)">
                                        <i class="fa fa-note" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript:void(0)" class="btn edit-btn-vvg waves-effect" title="Add/Edit Ticket No" v-on:click="addEditTicketNo(props.row.id, props.row.ticket_no)">
                                        <i class="fa fa-ticket" aria-hidden="true"></i>
                                    </a>
                                    <button type="submit" id="noteBtn" class="btn edit-btn-vvg waves-effect" title="View Note" v-on:click.prevent="viewNote(hideNoteFlag, props.row, $event, 'note')">
                                        <i class="fa fa-comment" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div v-else-if="props.column.field == 'customer_type'">
                                    <template v-if="props.row.customer_type == 'Pinnacle'">
                                        <p title="Pinnacle Customer">PIN</p>
                                    </template>
                                </div>
                                <div v-else-if="props.column.field == 'manager_name'">
                                    <p v-html="addNewLineInInovoiceColumn(props.formattedRow['manager_name'])"></p>
                                </div>
                                <div v-else-if="props.column.field == 'invoice_generate_type'">
                                    <template v-if="props.row.invoice_generate_type == 'VIP'">
                                        <img src="/static/images/vip.png" title="VIP" alt="VIP" style="width: 30px; height: 30px;">
                                    </template>
                                </div>
                                <div v-else-if="props.column.field == 'sales_name'">
                                    <p v-html="addNewLineInInovoiceColumn(props.formattedRow['sales_name'])"></p>
                                </div>
                                <div v-else-if="props.column.field == 'part_name' && props.formattedRow['customer_excede_id'] != 'Total'">
                                    <p style="padding-right: 2px;">{{props.formattedRow['part_name']}}</p>
                                    <button title="Part# Copy" type="button" class="btn btn-info" id="copyPartFunction" @click="copyFunction(props.formattedRow['part_name'], 'Part')">
                                        <span style="font-size: 12px;">Copy Part #</span>
                                    </button>
                                </div>
                                <div v-else-if="props.column.field == 'unique_po_number' && props.formattedRow['customer_excede_id'] != 'Total'">
                                    <!-- <div class="row"> -->
                                        <p style="padding-right: 2px;">{{props.formattedRow['unique_po_number']}}</p>
                                        <!-- <div style="padding-left: 10px;"> -->
                                            <button title="PO# Copy" type="button" class="btn btn-info" id="copyPOFunction" @click="copyFunction(props.formattedRow['unique_po_number'], 'PO')">
                                            <!-- <button title="PO # today" type="button" class="btn btn-info" id="copyPOFunction" @click="copyPOFunction(props.formattedRow['unique_po_number'])"> -->
                                                <!-- <i class="fa fa-clone" aria-hidden="true"></i> -->
                                                <span style="font-size: 12px;">Copy PO #</span>
                                                <!-- <span style="font-size: 12px;">PO # today</span> -->
                                            </button>
                                        <!-- </div> -->
                                    <!-- </div> -->
                                </div>
                                <div v-else-if="props.column.field == 'location_name'" class="dashboard-page">
                                    <!-- <template v-if="isEditLocation && props.row.location"> -->
                                    <template v-if="props.row.location">
                                        <!-- <v-select
                                            v-model="props.row.location.text"
                                            name="locationId"
                                            placeholder='Select Location'
                                            label="text"
                                            @change="changedValue"
                                            @search:blur="addUpdateLocation(props.row.id, props.row.location.text)"
                                            :options="locationArr"
                                            :clearable="false"
                                        >
                                        </v-select> -->
                                        <span>{{props.row.location.text}}</span>
                                    </template>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <div class="d-flex">
                                <v-select
                                    class="shipid-selectbox"
                                    style="min-width: 200px;"
                                    v-model="shipId"
                                    name="shipId"
                                    placeholder='Select Ship Id'
                                    label="text"
                                    @change="changedShipIdValue"
                                    :options="shipIdArr"
                                    :clearable="false"
                                >
                                </v-select>
                                <button id="sendAppUpdates" class="btn btn-primary my-1 ms-2" v-on:click.prevent="generateInvoice">Generate Invoice({{selectedRows}})</button>
                            </div>
                        </div>
                    </vue-good-table>
                </div>
      		</div>
      		<!--page content-->
            <div class="medium-modal">
                <b-modal ref="add-edit-backorder-note-modal" id="modallg" size="lg" title="Add/Edit Backorder QTY Note" class="modal-section" @hidden="closeModalEvent">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="col-md-12 col-sm-12">
                            Note:
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <input class="form-control" v-model="boNote" type="text" maxlength="190" />
                            <div class="requiredstar">*</div>
                            <span style="line-height: initial; border: 0;" class="text-danger">{{boNoteError}}</span>
                        </div>
                    </form>
                    <!--Buttons-->
                    <div class="button-demo" style="margin-left: 15px;">
                        <input style="margin-top: 10px;" id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="submitBackorderNote($event)">
                    </div>
                </b-modal>
                <b-modal ref="add-edit-ticket-no-modal" id="modallg" size="lg" title="Add/Edit Ticket No" class="modal-section" @hidden="closeModalEvent">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="col-md-12 col-sm-12">
                            Ticket No:
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <input class="form-control" v-model="ticketNo" type="text" maxlength="50" />
                            <div class="requiredstar">*</div>
                            <span style="line-height: initial; border: 0;" class="text-danger">{{ticketNoError}}</span>
                        </div>
                    </form>
                    <!--Buttons-->
                    <div class="button-demo" style="margin-left: 15px;">
                        <input style="margin-top: 10px;" id="addBenifitBtn" :disabled="disableButtons.saveTicketNo" type="submit" :value="buttonNames.saveTicketNo" class="btn btn-primary" v-on:click.prevent="submitTicketNo($event)">
                    </div>
                </b-modal>
            </div>

            <!-- Side Note View Section -->
            <div class="page-sidebar"> <!--v-if="windowWidth > 767"-->
                <div class="noteDetails">
                    <div v-if="type == 'note'">
                        <div class="forms-block">
                            <div class="pull-right ml-2">
                                <a id='cancelNote' title='Cancel Note' v-on:click.prevent="cancelNote()">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                            </div>
                            <div class="row clearfix"></div>
                            <div class="form-label mt-4">Note :</div>
                            <div class="">
                                <textarea name="notes" id="notes" v-model="notes" class="form-control"></textarea>
                                <div class="help is-danger">{{notesError}}</div>
                            </div>
                            <button type="submit" class="mt-3 btn btn-primary themebutton" style="float: left" v-on:click.prevent="addPartDepletionNote()">
                                <span id="createAttachment">Save</span>
                            </button>
                            <button type="submit" class="ml-2 mt-3 btn btn-primary themebutton" style="float: left" v-on:click.prevent="cancelNote()">
                                <span id="cancelNote">Cancel</span>
                            </button>
                        </div>

                        <div class="mt-3 sidebar-notes">
                            Note List :
                        </div>
                        <template v-if="notesArr && notesArr.length > 0">
                            <div class="col-md-12 sidebar-notes-details mt-0">
                                <template v-for="(note, index) in notesArr">
                                    <div :key="index">
                                        <div class="mb-4">
                                            <div class="username-letter text-center">{{note['imgString']}}</div>
                                            <div class="comment-details" style="display: inline-block; margin-left: 10px;">
                                                <p class="mb-0 user-name" style="color: #098de1; font-family: 'SanFranciscoDisplayMedium';">
                                                    {{note['name']}}
                                                </p>
                                                <p class="mb-0 comment-date" style="font-size: 14px; color: #8b8b8b;">
                                                    {{note['date']}}
                                                </p>
                                            </div>
                                        </div>
                                        <p class="mb-2">
                                            {{note['notes']}}
                                        </p>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <div class="sidebar-notes-details">
                                {{noDataMessaage}}
                            </div>    
                        </template>
                    </div>
                    <div v-else-if="type == 'cust'">
                        <div class="forms-block">
                            <div class="pull-right ml-2">
                                <a id='cancelNote' title='Cancel Note' v-on:click.prevent="cancelNote()">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                            </div>
                            <div class="row clearfix"></div>
                            <div class="form-label"><b><h4>{{cust_info.customer_name}}</h4></b></div>
                            <div class="form-label">Excede id: ({{cust_info.customer_excede_id}})</div>
                            <div class="form-label">Email: {{cust_info.customer_primary_email}}</div>
                            <div class="form-label">Phone: {{cust_info.customer_primary_contact}}</div>
                            <div class="form-label">Type: {{cust_info.customer_type}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Side Note View Section -->
    	</div>
		<app-footer></app-footer>
  	</div>
  <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from "./event-bus";
    import { commonMixins } from "../mixins/commonMixins";
    import { HTTP } from "../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from './NoAccessPermission';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';

    Vue.use(VueGoodTable);
    export default {
        name: "listInventory",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                roleId: 0,
                firstLoad: 0,
                isAdminClass: 'text-align-placeholder-user-admin-dashboard',
                customerId: "",
                customerOptions: [],
                columns: [
                    /* {
                        label: "Manager Name",
                        field: "manager_name",
                        filterable: true,
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Manager Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Salesman Name",
                        field: "sales_name",
                        filterable: true,
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Salesman Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Customer Type",
                        field: "customer_type",
                        filterable: false,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Type", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: "Customer EXCEDE Id",
                        field: "customer_excede_id",
                        // filterable: false,
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer EXCEDE Id", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Customer Name",
                        field: "customer_name",
                        // filterable: false,
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: "Inventory Name",
                        field: "inventory_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Inventory Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Part No",
                        field: "part_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Part No", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Description",
                        field: "part_description",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Description", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                        label: "Max Qty",
                        field: "part_max_qty",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Max Qty", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },*/
                    {
                        label: "QOH",
                        field: "part_qty",
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "QOH", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Used Qty",
                        field: "part_depletion_qty",
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Used Qty", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "BO QTY",
                        field: "back_order_qty",
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "BO QTY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "BO QTY Note",
                        field: "back_order_qty_note",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "BO QTY Note", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Ticket No",
                        field: "ticket_no",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Ticket No", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Updated By",
                        field: "depletion_updated_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Updated At",
                        field: "depletion_updated_at",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        },
                        width : '250px'
                    },
                    {
                        label: "Unit Price",
                        field: "part_unit_price",
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Unit Price", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "ExtPrice",
                        field: "part_ext_price",
                        type: "number",
                        filterable: false,
                        sortable: false,
                        thClass: "disable-sorting",
                    },
                    {
                        label: "PO Number",
                        field: "unique_po_number",
                        filterable: true,
                        // width: '300px',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "PO Number", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Date",
                        field: "purchase_work_order_date",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Invoice Generate Type",
                        field: "invoice_generate_type",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "VIP / Sync", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        // hidden: true,
                        thClass: "disable-sorting",
                        width : "150px"
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        // field: "inv_created_at",
                        field: "purchase_work_order_date",
                        // field: "work_order",
                        type: "desc"
                    },
                    perPageDropdown : [],
                },
                customer_name:'',
                recordsCounts: "",
                selectedRows: 0,
                // permissionsArray: ['can_create_invoice_in_excede'],
                permissionsArray: [],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                date_picker_options: {
					range: true,
					onlyDate: true,
					outputFormat: 'YYYY-MM-DD',
					inputFormat: 'YYYY-MM-DD',
					formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
					noClearButton: true,
					maxDate : '',
					// Getting error when using the for date picker options
					// 'no-shortcuts': false,
					customShortcuts : [
						{ key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: true },
						{ key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
						{ key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
						{ key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
						{ key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
					]
                },
                date_picker_dates: "",
                totalUsedQty: 0,
                loginUserRole: 'admin',
                editUserId: 1,
                boRowId: '',
                boNote: '',
                boNoteError: '',
                ticketNoRowId: '',
                ticketNo: '',
                ticketNoError: '',
                buttonNames : {
                    save : 'Submit',
                    saveTicketNo : 'Submit',
                },
                disableButtons : {
                    save : false,
                    saveTicketNo : false,
                },
                windowWidth: 0,
                hideNoteFlag: true,
                notes : '',
                notesArr: [],
                notesError : '',
                noDataMessaage: 'Notes are not available',
                partDepletionId : 0,
                locationArr : [],
                type: '',
                cust_info: null,
                isNonVVGDealer: 'NO',
                /* isEditLocation: false */
                customerId : 0,
                enableSelection: false,
                app_country: 'US',
                shipId: '',
                shipIdArr: [],
            };
        },
        computed: {
            dynamicSelectOptions() {
                return self.permissionsArray.includes('can_create_invoice_in_excede')
                ?   {
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }
                :   {
                        enabled: false,
                    };
            },
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "dashboard");
            self.hideNoteFlag = true;
            self.hideNoteSideBarView();
        },
        mounted: function() {
            self.getUserPermissions();

            self.app_country = process.env.APP_COUNTRY;
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            if(self.isNonVVGDealer == 'YES') {
                for(var i = 0; i < self.columns.length;i++){
                    if (self.columns[i].field == "customer_excede_id") {
                        self.$set(self.columns[i], 'hidden', true);
                    }
                }
            }

            self.loadFilters('admindashboard', self.columns, self.serverParams, 'AdminDashboard');
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                /* if(userJson['id'] == 1 || userJson['id'] == 122) {
                    for(var i = 0; i < self.columns.length;i++) {
                        if (self.columns[i].field == "action") {
                            self.$set(self.columns[i], 'hidden', false);
                        }
                    }
                } */
                self.editUserId = userJson['id'];
            }
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 380);
            });
            
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            self.date_picker_dates = {
				"start": moment().subtract(2, 'days'),
				"end": moment()
            };
            $(self.$refs['add-edit-backorder-note-modal']).on("hidden.bs.modal", self.closeModalEvent);
            $(self.$refs['add-edit-ticket-no-modal']).on("hidden.bs.modal", self.closeModalEvent);
            // self.loadMappedListData();
            self.loadPartDepletionHistory(false);
            window.setInterval(() => {
                self.loadPartDepletionHistory(false);
            }, 1200000)

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 380);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.dashboard .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            }, 500); */
            self.getAllLocationList('dashboard');
            if(self.app_country == 'US') {
                self.loadShipIdData();
            }
        },
        methods: {
            loadShipIdData: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/ship/master/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.shipIdArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            generateInvoice: function() {
                if (self.shipId == null || !self.shipId.value) {
                    self.showSAlert("Select Ship Id.", 'warning', false);
                    return false;
                }
                var strCustomerExcedeId = 0;
                var strPO = '';
                var customerCheck = true;
                var poCheck = true;
                var backOrderQtyCheck = true;
                var inventoryPartsArr = [];
                var customerPartsObj = {};
                var selectedInventoryParts = self.$refs["listInventory"].selectedRows;
                var strAmtSubtotal = 0.00;
                var invoicePartArr = [];
                for (var i = 0; i < selectedInventoryParts.length; i++) {
                    /* console.log(JSON.stringify(selectedInventoryParts[i]));
                    return; */
                    
                    if (i == 0) {
                        strCustomerExcedeId = selectedInventoryParts[i].customer_excede_id;
                        strPO = selectedInventoryParts[i].unique_po_number.trim();
                    } else {
                        if(strCustomerExcedeId != selectedInventoryParts[i].customer_excede_id) {
                            customerCheck = false;
                        }
                        if(strPO != selectedInventoryParts[i].unique_po_number.trim()) {
                            poCheck = false;
                        }
                    }
                    if(selectedInventoryParts[i].back_order_qty > 0) {
                        backOrderQtyCheck = false;
                    }
                    customerPartsObj = {};
                    customerPartsObj.id = selectedInventoryParts[i].id;
                    customerPartsObj.customer_excede_id = selectedInventoryParts[i].customer_excede_id;
                    customerPartsObj.customer_name = selectedInventoryParts[i].customer_name;
                    customerPartsObj.invoice_no = selectedInventoryParts[i].invoice_no;
                    customerPartsObj.back_order_qty = selectedInventoryParts[i].back_order_qty != '' ? selectedInventoryParts[i].back_order_qty : 0;

                    var tempPO = selectedInventoryParts[i].unique_po_number.replace('CI-', '');
                    customerPartsObj.unique_po_number = tempPO.trim();

                    var tempPrice = selectedInventoryParts[i].part_ext_price;
                    tempPrice = parseFloat(tempPrice.replace("$", ''));
                    strAmtSubtotal = strAmtSubtotal + tempPrice;

                    if((i) == selectedInventoryParts.length - 1) {
                        customerPartsObj.part_ext_price = strAmtSubtotal.toFixed(2);
                    }
                    var locArr = selectedInventoryParts[i].location_name;
                    locArr = locArr.split(' (');
                    customerPartsObj.brn_id = locArr[1].replace(')', '');
                    // inventoryPartsArr.push(selectedInventoryParts[i].id);
                    inventoryPartsArr.push(selectedInventoryParts[i].id);
                    invoicePartArr.push(customerPartsObj);
                }
                if(!customerCheck) {
                    self.showSAlert("Please select only one customer line item", 'warning', false);
                    return false;
                }
                if(!poCheck) {
                    // self.showSAlert("Please select line items with the same PO number.", 'error', false);
                    self.showSAlert("Please select line items with the same PO number.", 'warning', false);
                    return false;
                }
                /* if(!backOrderQtyCheck) {
                    self.showSAlert("You have selected bo qty inventory parts", 'warning', false);
                    return false;
                } */

                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };
                var fields = {
                    inventory_parts: inventoryPartsArr,
                    customer_part: customerPartsObj,
                    invoice_part: invoicePartArr,
                    ship_id: self.shipId.value,
                };

                self.$swal({
                    title: "Are you sure you want to create parts order in EXCEDE?",
                    text: "Once you submit this order you will not be able to make changes.",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Submit Order",
                    cancelButtonText: "No, Make Changes",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then(result => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post("/invoice/create", fields, config)
                            .then(function(response) {
                                self.hideLoader();
                                if(response.data.code == 200) {
                                    self.$swal("Created", response.data.message, "success");
                                    self.shipId = '';
                                    self.loadPartDepletionHistory(false);
                                } else {
                                    self.$swal("VIP", response.data.message, "warning");
                                }
                            })
                            .catch(function(err) {
                                self.hideLoader();
                                // console.log(err);
                                self.catchHandler(err);
                            });
                    }
                })

            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            changedShipIdValue: function (value) {
                /*console.log(value);*/
            },
            addUpdateLocation: function(id, locId) {
                /* self.isEditLocation = false; */
                var partDepletionIdArr = [];
                if (id) {
                    partDepletionIdArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        partDepletionIdArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var config = {
                };
                var fields = {
                    id: partDepletionIdArr,
                    locId: locId.value,
                };
                HTTP.post("/add/update/partsdepletion/location", fields, config)
                    .then(function(response) {
                       self.loadPartDepletionHistory(false);
                    })
                    .catch(function(err) {
                        self.$refs['my-modal'].hide();
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                        }
                    });
            },
            cancelNote : function() {
                self.hideNoteFlag = true;
                self.hideNoteSideBarView();
            },
            hideNoteSideBarView : function() {
                self.hideContactflag = true;
                /* $('.noteDetails').fadeOut(); */
                $('.page-sidebar').fadeOut(100).addClass('hide');
                setTimeout(function () {
                    $('.page-sidebar').addClass('zeroWidth');
                    $('#wrapper').removeClass('right-sidebar');
                    if (self.windowWidth > 767) {
                        $('.page-sidebar').show();
                        // $('.internal-container').removeClass('openDetailview');
                    } else {
                        $('.page-sidebar').hide();
                    }
                }, 300);
            },
            viewNote(hide, row, e, type) {
                self.type = type
                $('#info_panel_' + row.id).removeClass('open');
                if(e) {
                    self.showNote(hide, row.id);
                }
                if(type == 'cust') {
                    self.cust_info = row
                }
                self.customerId = row.customer_id;
            },
            showNote(hide, rowId) {
                hide = (hide === null || typeof (hide) === "undefined" || hide == '') ? false : hide;
                if (!hide) {
                    self.hideNoteSideBarView();
                } else {
                    var classavailable = $('.page-sidebar').attr('class');
                    if (typeof (classavailable) != 'undefined') {
                        if (classavailable.indexOf('zeroWidth') > 0) {
                            self.hideContactflag = false;
                            $('.page-sidebar').removeClass('zeroWidth');
                            $('#wrapper').addClass('right-sidebar');
                            if (self.windowWidth > 767) {
                                $('.page-sidebar').show();
                            } else {
                                $('.page-sidebar').hide();
                            }
                            /* $('.noteDetails').fadeIn(); */
                            $('.page-sidebar').fadeIn().removeClass('hide');
                        } else {
                            self.hideContactflag = true;
                            /* $('.noteDetails').fadeOut(); */
                            $('.page-sidebar').fadeOut(100).addClass('hide');
                            setTimeout(function () {
                                $('.page-sidebar').addClass('zeroWidth');
                                $('#wrapper').removeClass('right-sidebar');
                                if (self.windowWidth > 767) {
                                    $('.page-sidebar').show();
                                } else {
                                    $('.page-sidebar').hide();
                                }
                            }, 300);
                        }
                    } else {
                        self.hideContactflag = false;
                        $('.page-sidebar').removeClass('zeroWidth');
                        $('#wrapper').addClass('right-sidebar');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                        } else {
                            $('.page-sidebar').hide();
                        }
                        /* $('.noteDetails').fadeIn(); */
                        $('.page-sidebar').fadeIn().removeClass('hide');
                    }
                }

                if(rowId != '' && (typeof(rowId) != 'undefined') && rowId != 0) {
                    self.partDepletionId = rowId;
                    self.getPartDepletionHistoryData(rowId);
                }
            },
            getPartDepletionHistoryData: function(partDepletionId) {
                var config = {
                        headers: {
                            Authorization : localStorage.getItem("access_token")
                        },
                        params : {
                            part_depletion_id: partDepletionId,
                        }
                    };
                HTTP.get("/partdepletion/history/get", config)
                    .then(function (response) {
                        if (response.status == 200) {
                            self.notesArr = [];
                            if(response.data.notes && response.data.notes.length > 0) {
                                self.notesArr = response.data.notes;
                            }
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });

            },
            addPartDepletionNote() {
                self.notesError = "";
                if (!self.notes) {
                    self.notesError = "Please Enter Note";
                    return false;
                }
                var config = {
                    headers: {
                        Authorization : localStorage.getItem("access_token")
                    },
                };
                var fields = {
                    part_depletion_id: self.partDepletionId,
                    notes: self.notes,
                    customer_id: self.customerId
                };
                HTTP.post("/partdepltionhistorydata/notes", fields, config)
                    .then(function (response) {
                        if (response.data.status == "success") {
                            self.getPartDepletionHistoryData(self.partDepletionId);
                            self.notes = "";
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            rowStyleClassFn: function(row) {
                /* if(row.is_invoice_pending && row.part_no != 'Total') {
                    return 'invoice-not-generated';
                } */
            },
            closeModalEvent: function() {
                self.boNoteError = self.ticketNoError = '';
            },
            addEditBackorderQtyNote: function(id, boNote) {
                self.boRowId = id;
                self.boNote = boNote;
                self.$refs['add-edit-backorder-note-modal'].show();
            },
            checkForm: function() {
                var checked = true;
                self.boNoteError = '';
                if (!self.boNote) {
                    self.boNoteError = "Backorder QTY Note Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            submitBackorderNote: function() {
                setTimeout(() => {
                    if(self.checkForm()) {
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        self.disableButtons.save = true;
                        self.buttonNames.save = "Submitting ...";
                        var fields = {
                            depletion_id: self.boRowId,
                            bo_note: self.boNote
                        };
                        HTTP.post("/backorder/note/add/update", fields, config)
                            .then(function (response) {
                                self.$refs['add-edit-backorder-note-modal'].hide();
                                self.loadPartDepletionHistory(false);
                                self.disableButtons.save = false;
                                self.buttonNames.save = "Submit";
                            })
                            .catch(function (err) {
                                self.$refs['add-edit-backorder-note-modal'].hide();
                                self.disableButtons.save = false;
                                self.buttonNames.save = "Submit";
                                self.catchHandler(err);
                            });
                    }
                }, 200);
            },
            addEditTicketNo: function(id, ticketNo) {
                self.ticketNoRowId = id;
                self.ticketNo = ticketNo;
                self.$refs['add-edit-ticket-no-modal'].show();
            },
            checkTicketNoForm: function() {
                var checked = true;
                self.ticketNoError = '';
                if (!self.ticketNo) {
                    self.ticketNoError = "Ticket No Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            submitTicketNo: function() {
                setTimeout(() => {
                    if(self.checkTicketNoForm()) {
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        self.disableButtons.saveTicketNo = true;
                        self.buttonNames.saveTicketNo = "Submitting ...";
                        var fields = {
                            depletion_id: self.ticketNoRowId,
                            ticket_no: self.ticketNo
                        };
                        HTTP.post("/ticket/no/add/update", fields, config)
                            .then(function (response) {
                                self.$refs['add-edit-ticket-no-modal'].hide();
                                self.loadPartDepletionHistory(false);
                                self.disableButtons.saveTicketNo = false;
                                self.buttonNames.saveTicketNo = "Submit";
                            })
                            .catch(function (err) {
                                self.$refs['add-edit-ticket-no-modal'].hide();
                                self.disableButtons.saveTicketNo = false;
                                self.buttonNames.saveTicketNo = "Submit";
                                self.catchHandler(err);
                            });
                    }
                }, 200);
            },
            changeDatePickerDate : function () {
              // self.datePickerError = '';   
            },
            loadMappedListData() {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                var url = "/customer/binded/get";
                HTTP.get(url, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            if(response.data.content && response.data.content.length > 0) {
                                self.customerId = {text: response.data.content[0].text, value: response.data.content[0].value};
                            }
                            self.customerOptions = response.data.content;
                            // self.loadPartDepletionHistory(false);
                        }
                    })
                    .catch(function (error) {
                        // self.catchHandler(error);
                    })
            },
            onChangeCustomer: function() {
                self.loadPartDepletionHistory(false);
            },
            clearFilter(){
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                self.loadPartDepletionHistory(false);
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadPartDepletionHistory(false);
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadPartDepletionHistory(false);
            },
            changeStatusUser : function(userId) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };

                var fields = {
                    user_id: userId
                };

                self.$swal({
                    title: "Are you sure?",
                    text: "You want to change the status",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes Change it!",
                    cancelButtonText: "No, Keep it!",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("/user/change-user-status", fields, config)
                                .then(function(response) {
                                    self.loadPartDepletionHistory(false);
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        }

                    });
            },
            backToCustomerList: function() {
                self.$router.push({name:'ListCustomer'});
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadPartDepletionHistory(false);
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadPartDepletionHistory(false);
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "manager_name";
                    field: "sales_name";
                    field: "customer_name";
                    field: "part_name";
                    field: "part_depletion_qty";
                    field: "part_unit_price";
                    field: "part_ext_price";
                    field: "work_order";
                    field: "inv_updated_at";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.manager_name ||
                    filters.sales_name ||
                    filters.customer_name ||
                    filters.part_depletion_qty ||
                    filters.part_unit_price ||
                    filters.part_ext_price ||
                    filters.work_order ||
                    filters.inv_updated_at
                ) {
                    self.loadPartDepletionHistory(false);
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listInventory"].selectedRows.length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadPartDepletionHistory(false);
            },

            deleteInventory: function(id) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    }
                };

                if (id) {
                    inventoryArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        inventoryArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: inventoryArr
                };

                self.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes Delete it!",
                    cancelButtonText: "No, Keep it!",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {
					if (result.value) {
						HTTP.post("delete-inventory", fields, config)
							.then(function(response) {
								self.loadPartDepletionHistory(false);
							})
							.catch(function(err) {
								if (err.response.status == 0) {
									self.error = "Remote server can not be reachable";
								} else {
									//redirect to login page if user not authenticated
									if (err.response.status == 401) {
										//clear previous data
										localStorage.clear();
										self.$router.push("/");
									}
								}
							});
						self.$swal("Deleted", "You successfully deleted record(s)", "success");
					} else {
						self.$swal("Cancelled", "Your file is still intact", "info");
					}
				});
            },

            loadPartDepletionHistory: function(isExport) {
                var partNo = '';
                var excedeCustomerId = '';
                if(localStorage.getItem('part_no') && localStorage.getItem('excede_customer_id')) {
                    partNo = localStorage.getItem('part_no');
                    excedeCustomerId = localStorage.getItem('excede_customer_id');
                    $.map(self.serverParams.columnFilters, function (val, key) {
                        $.each(self.columns, function (i) {
                            if (self.columns[i].field == key) {
                                self.columns[i].filterOptions.filterValue = '';
                                if(self.columns[i].field == 'customer_excede_id' && key == 'customer_excede_id') {
                                    self.columns[i].filterOptions.filterValue = excedeCustomerId;
                                }
                                if(self.columns[i].field == 'part_name' && key == 'part_name') {
                                    self.columns[i].filterOptions.filterValue = partNo;
                                }
                            }
                        })
                    });
                    localStorage.removeItem('part_no');
                    localStorage.removeItem('excede_customer_id');
                }
                self.$nextTick(() => {
                    self.storeFilters('admindashboard', self.serverParams, false);
                    self.totalUsedQty = 0;
                    self.firstLoad = 1;
                    if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                    }
                    var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                    if (newPage) {
                        if (newPage < self.serverParams.page) {
                            self.serverParams.page = newPage;
                        }
                    }
                    var config = {
                        headers: {
                            Authorization:localStorage.getItem("access_token")
                        },
                        params : {
                            page: self.serverParams.page,
                            perPage: self.serverParams.perPage,
                            filters: self.serverParams.columnFilters,
                            messageData: self.message,
                            sort: self.serverParams.sort,
                            // from_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.start).format("YYYY-MM-DD") : "",
                            // to_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.end).format("YYYY-MM-DD") : "",
                            from_date: "",
                            to_date: "",
                            tz: moment.tz.guess(),
                            isExport: isExport,
                            // customerSearch: self.customerId.text,
                        }
                    };
                    HTTP.get("parts-depletion-by-inventory", config)
                        .then(function(response) {
                            //console.log('inventory',response);
                            if (response.status == "200") {
                                if(response.data.message == "success export") {
                                    location.href = response.data.content;
                                } else {
                                    self.loginUserRole = response.data.loginUserRole;
                                    self.rows = response.data.history_list.data;
                                    self.totalRecords = response.data.totalRecords;
                                    //self.customer_name = response.data.customer_name;
                                    // $('.loading-container').hide();
                                    self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                                    self.hideVueGoodTableColumnRoleWise(response);
                                }
                            }
                        }).catch(function(err) {
                            console.log('err', err)
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.clear();
                                    self.$router.push("/");
                                }
                                self.error = err.response.data.message;
                            }
                        });
                });
            },
            hideVueGoodTableColumnRoleWise: function(response) {
                self.rows.push({
                    customer_excede_id: "Total",
                    customer_name: "",
                    part_name: "",
                    part_depletion_qty: response.data.usedQty,
                    part_unit_price: response.data.unitPriceTotal,
                    part_ext_price: response.data.partExtTotal,
                    work_order: "",
                    inv_updated_at: '',
                });
            },
            openInfo: function(id) {
                // self.closeAllChatPanel();
                $('#info_panel_'+id).addClass('open');
            },
            closeInfo (id) {
                // self.closeAllChatPanel();
                $('#info_panel_'+id).removeClass('open');
            },
            async copyFunction(value, fieldName) {
                try {
                    await navigator.clipboard.writeText(value);
                    self.$toasted.show(fieldName + "# Copied");
                } catch($e) {
                    self.$toasted.show("Cannot copy " + fieldName + "#");
                }
            }
        }
    };
    EventBus.$on('all-location-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.locationArr = response;
            self.locationArr = self.locationArr.map(item => { 
                return { value: item.id, text: item.name }; 
            });
        }
    });
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>

<style>
.shipid-selectbox.v-select li > a{
    margin: 0;
    white-space: normal;
}
.shipid-selectbox.v-select li:hover{
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue